import { render, staticRenderFns } from "./DetailsAppointment.vue?vue&type=template&id=6835381a"
import script from "./DetailsAppointment.vue?vue&type=script&lang=js"
export * from "./DetailsAppointment.vue?vue&type=script&lang=js"
import style0 from "./DetailsAppointment.vue?vue&type=style&index=0&id=6835381a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTab from 'quasar/src/components/tabs/QTab.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QBtn,QTooltip,QCardSection,QTab});qInstall(component, 'directives', {ClosePopup});
